export const LOKASI_ABSEN = {
  3: 'Gedung C',
  4: 'Gedung A (Satpam)',
  5: 'Gedung A (Mesin Fotocopy)',
  6: 'Gedung Baru',
  7: 'Salemba'
}